import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiDrawer from '@material-ui/core/Drawer';
import { combineClasses, combineProps, styled, useRcPortalWindowContext, useThemeProps, } from '../../foundation';
import { DrawerStyle } from './styles';
import { RcDrawerClasses } from './utils';
import { usePortalManagerWithID, useUnmountPortalHandler } from '../PortalHost';
import { HasPortalParentProvider } from '../PortalHost/context/HasPortalParentContext';
import { RcBackdrop } from '../Backdrop';
var _RcDrawer = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcDrawer' });
    var inlinePaper = props.inlinePaper, radius = props.radius, classesProp = props.classes, children = props.children, PaperPropsProp = props.PaperProps, onClose = props.onClose, SlidePropsProp = props.SlideProps, rest = __rest(props, ["inlinePaper", "radius", "classes", "children", "PaperProps", "onClose", "SlideProps"]);
    var externalWindow = useRcPortalWindowContext().externalWindow;
    var PaperProps = useMemo(function () {
        var _a;
        return combineProps((_a = {},
            _a['data-mui-paper'] = true,
            _a.onClick = inlinePaper
                ? function (e) {
                    var _a;
                    if ((_a = e.target) === null || _a === void 0 ? void 0 : _a.dataset.muiPaper) {
                        onClose === null || onClose === void 0 ? void 0 : onClose(e, 'backdropClick');
                    }
                }
                : undefined,
            _a), PaperPropsProp);
    }, [PaperPropsProp, inlinePaper, onClose]);
    var classes = useMemo(function () { return combineClasses(RcDrawerClasses, classesProp); }, [classesProp]);
    var onExited = useUnmountPortalHandler(SlidePropsProp === null || SlidePropsProp === void 0 ? void 0 : SlidePropsProp.onExited);
    var managerWithID = usePortalManagerWithID();
    var SlideProps = __assign(__assign(__assign({}, SlidePropsProp), { onExited: onExited }), (managerWithID ? { appear: true } : {}));
    return (React.createElement(HasPortalParentProvider, null,
        React.createElement(MuiDrawer, __assign({ BackdropComponent: RcBackdrop }, rest, { ref: ref, container: externalWindow === null || externalWindow === void 0 ? void 0 : externalWindow.document.body, classes: classes, onClose: onClose, PaperProps: PaperProps, SlideProps: SlideProps }), children)));
});
var RcDrawer = styled(_RcDrawer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), DrawerStyle);
RcDrawer.defaultProps = {
    radius: 'lg',
};
RcDrawer.displayName = 'RcDrawer';
export { RcDrawer };
var templateObject_1;
